<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Ventes Unitaires</h4>
            <h6>Suivi des ventes directes par produit</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Rafraîchir" @click.prevent="refreshList">
              <i data-feather="rotate-ccw" class="feather-rotate-ccw"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a v-can="'unit_sales.create'" href="javascript:void(0);" class="btn btn-added" data-bs-toggle="modal" data-bs-target="#unit-sale-modal"
            @click="openCreateModal">
            <vue-feather type="plus-circle" class="me-2" />
            Enregistrer une vente
          </a>
        </div>
      </div>

      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top mb-3">
            <div class="row g-3 align-items-end">
              <div class="col-xl-3 col-lg-3 col-sm-6">
                <label class="form-label">Catégorie</label>
                <vue-select :options="categoryOptions" label="text" :reduce="option => option?.id ?? null"
                  placeholder="Toutes les catégories" v-model="filters.category"
                  @update:modelValue="onFilterCategoryChange" :clearable="true" />
              </div>
              <div class="col-xl-3 col-lg-3 col-sm-6">
                <label class="form-label">Produit</label>
                <vue-select :options="filterProductOptions" label="text" :reduce="option => option?.id ?? null"
                  placeholder="Tous les produits" v-model="filters.productId" :clearable="true"
                  @update:modelValue="applyFilters" />
              </div>
              <div class="col-xl-3 col-lg-3 col-sm-6">
                <label class="form-label">Utilisateur</label>
                <vue-select :options="filterUserOptions" label="text" :reduce="option => option?.id ?? null"
                  placeholder="Tous les utilisateurs" v-model="filters.userId" :clearable="true"
                  @update:modelValue="applyFilters" />
              </div>
              <div class="col-xl-3 col-lg-3 col-sm-6">
                <label class="form-label">Date de début</label>
                <input type="date" class="form-control" v-model="filters.dateFrom" @change="applyFilters" />
              </div>
              <div class="col-xl-3 col-lg-3 col-sm-6">
                <label class="form-label">Date de fin</label>
                <input type="date" class="form-control" v-model="filters.dateTo" @change="applyFilters" />
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <a-table :columns="columns" :data-source="salesData" :loading="isLoading" class="table datanew"
              row-key="id">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'status'">
                  <span class="badge badge-linesuccess">Vente</span>
                </template>
                <template v-else-if="column.key === 'action'">
                  <div class="d-flex justify-content-center gap-2">
                    <button v-can="'unit_sales.update'" class="btn btn-sm btn-outline-primary" type="button" @click.prevent="openEditSale(record)"
                      title="Modifier la vente">
                      <vue-feather type="edit-2" size="15"></vue-feather>
                    </button>
                    <button v-can="'unit_sales.delete'" class="btn btn-sm btn-outline-danger" type="button"
                      @click.prevent="confirmDeleteSale(record)" title="Supprimer la vente">
                      <vue-feather type="trash-2" size="15"></vue-feather>
                    </button>
                  </div>
                </template>
                <template v-else>
                  {{ record[column.dataIndex] || "—" }}
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="unit-sale-modal" tabindex="-1" aria-labelledby="unitSaleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h5 class="modal-title" id="unitSaleModalLabel">
            Enregistrer une vente unitaire
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitSale">
            <div class="row g-3">
              <div class="col-lg-6">
                <label class="form-label">Catégorie</label>
                <vue-select :options="categoryOptions" label="text" :reduce="option => option?.id ?? null"
                  placeholder="Sélectionner une catégorie" v-model="form.category" :clearable="true"
                  @update:modelValue="onModalCategoryChange" />
              </div>
              <div class="col-lg-6">
                <label class="form-label">Produit</label>
                <vue-select :options="modalProductOptions" placeholder="Sélectionner un produit"
                  v-model="form.produit_id" :settings="productSelectSettings"
                  @select="onModalProductSelect" :disabled="!modalProductOptions.length" required />
              </div>
              <div class="col-lg-4">
                <label class="form-label">Quantité</label>
                <input type="number" min="1" step="1" class="form-control" v-model.number="form.quantity" required />
              </div>
              <div class="col-lg-4">
                <label class="form-label">Prix unitaire (optionnel)</label>
                <input type="number" :min="unitPriceMin || 0" step="0.01" class="form-control"
                  v-model.number="form.unit_price" />
              </div>
              <div class="col-lg-4">
                <label class="form-label">Date de vente</label>
                <input type="date" class="form-control" v-model="form.sale_date" required />
              </div>
              <div class="col-12">
                <label class="form-label">Note (optionnel)</label>
                <textarea class="form-control" rows="2" v-model="form.note" maxlength="255"
                  placeholder="Commentaire rapide"></textarea>
              </div>
            </div>
            <div class="modal-footer border-0 mt-3">
              <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                Annuler
              </button>
              <button type="submit" class="btn btn-submit">
                Enregistrer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import Swal from "sweetalert2";
import { toast } from "vue3-toastify";
import {
  getProductsData,
  getProductUnitSales,
  createProductUnitSale,
  updateProductUnitSale,
  deleteProductUnitSale,
} from "@/services/productsService";
import { getUsers } from "@/services/userService";
import { getCurrentUser } from "@/services/authService";

export default {
  data() {
    return {
      columns: [
        {
          title: "Date",
          dataIndex: "saleDate",
          key: "saleDate",
          sorter: {
            compare: (a, b) =>
              new Date(a.saleDateIso || a.saleDate) -
              new Date(b.saleDateIso || b.saleDate),
          },
        },
        {
          title: "Produit",
          dataIndex: "productName",
          key: "productName",
          sorter: {
            compare: (a, b) =>
              (a.productName || "").localeCompare(b.productName || "", "fr"),
          },
        },
        {
          title: "Quantité",
          dataIndex: "quantity",
          key: "quantity",
          sorter: {
            compare: (a, b) => (a.quantity || 0) - (b.quantity || 0),
          },
        },
        {
          title: "Prix unitaire",
          dataIndex: "unitPrice",
          key: "unitPrice",
          sorter: {
            compare: (a, b) => (a.unitPriceValue || 0) - (b.unitPriceValue || 0),
          },
        },
        {
          title: "Total",
          dataIndex: "subtotal",
          key: "subtotal",
          sorter: {
            compare: (a, b) => (a.subtotalValue || 0) - (b.subtotalValue || 0),
          },
        },
        {
          title: "Vendu par",
          dataIndex: "userName",
          key: "userName",
          sorter: {
            compare: (a, b) =>
              (a.userName || "").localeCompare(b.userName || "", "fr"),
          },
        },
        {
          title: "Note",
          dataIndex: "note",
          key: "note",
        },
        {
          title: "Créé le",
          dataIndex: "createdOn",
          key: "createdOn",
          sorter: {
            compare: (a, b) =>
              new Date(a.createdAtIso || a.createdOn) -
              new Date(b.createdAtIso || b.createdOn),
          },
        },
        {
          title: "Action",
          dataIndex: "action",
          key: "action",
          sorter: false,
        },
      ],
      salesData: [],
      isLoading: false,
      allProducts: [],
      categoryOptions: [{ id: null, text: "Toutes les catégories" }],
      filterProductOptions: [{ id: null, text: "Tous les produits" }],
      modalProductOptions: [],
      productSelectSettings: {
        dropdownParent: "#unit-sale-modal",
        minimumResultsForSearch: 0,
        width: "100%",
        allowClear: false,
        language: {
          noResults: () => "Aucun produit trouvé",
          searching: () => "Recherche...",
          inputTooShort: () => "Saisissez le nom du produit",
        },
      },
      userOptions: [],
      filterUserOptions: [{ id: null, text: "Tous les utilisateurs" }],
      currentUserId: null,
      currentUserRole: null,
      editingSaleId: null,
      unitPriceMin: 0,
      filters: {
        category: null,
        productId: null,
        userId: null,
        dateFrom: "",
        dateTo: "",
      },
      form: this.getEmptyForm(),
      modalInstance: null,
    };
  },
  computed: {
    isAdminUser() {
      return (this.currentUserRole || "").toLowerCase() === "admin";
    },
  },
  methods: {
    getEmptyForm() {
      const today = new Date().toISOString().slice(0, 10);
      return {
        category: null,
        produit_id: null,
        quantity: 1,
        unit_price: null,
        sale_date: today,
        note: "",
      };
    },
    extractDatePart(value) {
      if (!value) {
        return "";
      }
      if (value instanceof Date) {
        return value.toISOString().slice(0, 10);
      }
      const normalized = String(value).trim();
      const matched = normalized.match(/^\d{4}-\d{2}-\d{2}/);
      if (matched) {
        return matched[0];
      }
      const parsed = new Date(normalized);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed.toISOString().slice(0, 10);
      }
      return "";
    },
    async loadInitialData() {
      try {
        const [products, users] = await Promise.all([
          getProductsData(),
          getUsers(),
        ]);

        this.allProducts = Array.isArray(products) ? products : [];
        this.buildCategoryOptions();
        this.updateFilterProductOptions();
        this.updateModalProductOptions();

        this.userOptions = (users || []).map((u) => ({
          id: Number(u.id),
          text: u.name || `Utilisateur #${u.id}`,
        }));

        if (
          this.currentUserId &&
          !this.userOptions.some((option) => option.id === this.currentUserId)
        ) {
          const current = getCurrentUser();
          this.userOptions.push({
            id: this.currentUserId,
            text: current?.name || `Utilisateur #${this.currentUserId}`,
          });
        }

        this.buildFilterUserOptions();

        if (!this.currentUserId && this.userOptions.length) {
          this.currentUserId = this.userOptions[0].id;
        }

        if (!this.form.user_id && this.currentUserId) {
          this.form.user_id = this.currentUserId;
        }

      } catch (error) {
        console.error(error);
        toast.error(
          error?.response?.data?.message ||
          "Impossible de charger les listes de produits ou d'utilisateurs."
        );
      }
    },
    async loadSales() {
      this.isLoading = true;
      try {
        const params = {};
        if (this.filters.productId) {
          params.produit_id = Number(this.filters.productId);
        }
        if (this.filters.userId) {
          params.user_id = Number(this.filters.userId);
        }
        if (this.filters.dateFrom) {
          params.date_from = this.filters.dateFrom;
        }
        if (this.filters.dateTo) {
          params.date_to = this.filters.dateTo;
        }
        const data = await getProductUnitSales(params);

        if (Array.isArray(data?.products)) {
          this.allProducts = data.products;
          this.buildCategoryOptions();
        }

        if (Array.isArray(data?.users)) {
          this.userOptions = data.users.map((u) => ({
            id: Number(u.id),
            text: u.name || `Utilisateur #${u.id}`,
          }));
          if (
            this.currentUserId &&
            !this.userOptions.some((option) => option.id === this.currentUserId)
          ) {
            this.userOptions.push({
              id: this.currentUserId,
              text: `Utilisateur #${this.currentUserId}`,
            });
          }
          if (!this.currentUserId && this.userOptions.length) {
            this.currentUserId = this.userOptions[0].id;
          }
        }
        this.buildFilterUserOptions();

        this.updateFilterProductOptions();
        this.updateModalProductOptions();

        let rows = Array.isArray(data?.sales)
          ? data.sales.map((sale) => this.mapSaleToRow(sale))
          : Array.isArray(data)
            ? data.map((sale) => this.mapSaleToRow(sale))
            : [];

        if (this.filters.category) {
          const allowedIds = new Set(
            this.getProductIdsByCategory(this.filters.category)
          );
          rows = rows.filter((row) => allowedIds.has(row.productId));
        }

        this.salesData = rows;
      } catch (error) {
        console.error(error);
        toast.error(
          error?.response?.data?.message ||
          "Impossible de récupérer les ventes unitaires."
        );
      } finally {
        this.isLoading = false;
      }
    },
    mapSaleToRow(sale) {
      const appLocale = localStorage.getItem("app_locale") || "fr";
      const dateLocale = appLocale === "ar" ? "ar-MA" : appLocale === "en" ? "en-GB" : "fr-MA";
      const saleDate = sale.sale_date
        ? new Date(sale.sale_date)
        : new Date(sale.created_at);
      const createdOn = sale.created_at ? new Date(sale.created_at) : saleDate;
      const saleDateIso =
        this.extractDatePart(sale.sale_date) ||
        saleDate.toISOString().slice(0, 10);
      return {
        id: sale.id,
        productId: Number(sale.produit_id),
        userId: Number(sale.user_id),
        saleDate: new Intl.DateTimeFormat(dateLocale, {
          day: "2-digit",
          month: "long",
          year: "numeric",
        }).format(saleDate),
        saleDateIso,
        productName: sale.produit?.nom || "—",
        quantity: Number(sale.quantity || 0),
        unitPrice:
          sale.unit_price !== null && sale.unit_price !== undefined
            ? `${Number(sale.unit_price).toFixed(2)} MAD`
            : "—",
        unitPriceValue:
          sale.unit_price !== null && sale.unit_price !== undefined
            ? Number(sale.unit_price)
            : null,
        subtotal:
          sale.unit_price !== null && sale.unit_price !== undefined
            ? `${(Number(sale.unit_price) * Number(sale.quantity || 0)).toFixed(2)} MAD`
            : "—",
        subtotalValue:
          sale.unit_price !== null && sale.unit_price !== undefined
            ? Number(sale.unit_price) * Number(sale.quantity || 0)
            : null,
        userName: sale.user?.name || "—",
        note: sale.note || "—",
        noteRaw: sale.note,
        createdOn: new Intl.DateTimeFormat(dateLocale, {
          day: "2-digit",
          month: "long",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }).format(createdOn),
        createdAtIso: sale.created_at,
      };
    },
    buildCategoryOptions() {
      const categories = Array.from(
        new Set(
          this.allProducts
            .map((product) => product.categorie_produit)
            .filter((value) => value && value.toString().trim() !== "")
        )
      );
      const options = categories.map((category) => ({
        id: category,
        text: category,
      }));
      this.categoryOptions = [
        { id: null, text: "Toutes les catégories" },
        ...options,
      ];
    },
    buildProductOptions(categoryValue = null) {
      return this.allProducts
        .filter(
          (product) =>
            product &&
            product.id != null &&
            (!categoryValue ||
              product.categorie_produit === categoryValue)
        )
        .map((product) => ({
          id: Number(product.id),
          text: product.nom || `Produit #${product.id}`,
          category: product.categorie_produit,
          unitPrice: Number(product.prix_vente) || 0,
        }));
    },
    buildFilterUserOptions() {
      this.filterUserOptions = [
        { id: null, text: "Tous les utilisateurs" },
        ...this.userOptions.map((option) => ({ ...option })),
      ];
      if (
        this.filters.userId &&
        !this.userOptions.some((option) => option.id === this.filters.userId)
      ) {
        this.filters.userId = null;
      }
    },
    updateFilterProductOptions() {
      const options = this.buildProductOptions(this.filters.category);
      this.filterProductOptions = [
        { id: null, text: "Tous les produits" },
        ...options,
      ];
      if (
        this.filters.productId &&
        !options.some((option) => option.id === this.filters.productId)
      ) {
        this.filters.productId = null;
      }
    },
    updateModalProductOptions() {
      this.modalProductOptions = this.buildProductOptions(
        this.form.category
      );
      this.updateUnitPriceConstraints(this.form.produit_id);
    },
    getProductIdsByCategory(categoryValue) {
      if (!categoryValue) {
        return this.allProducts
          .filter((product) => product && product.id != null)
          .map((product) => Number(product.id));
      }
      return this.allProducts
        .filter(
          (product) =>
            product &&
            product.categorie_produit === categoryValue
        )
        .map((product) => Number(product.id));
    },
    applyFilters() {
      this.loadSales();
    },
    refreshList() {
      this.loadSales();
    },
    onFilterCategoryChange(value) {
      this.filters.category = value;
      this.updateFilterProductOptions();
      if (
        this.filters.productId &&
        !this.filterProductOptions.some(
          (option) => option.id !== null && option.id === this.filters.productId
        )
      ) {
        this.filters.productId = null;
      }
      if (!this.filters.productId && this.filterProductOptions.length === 2) {
        this.filters.productId = this.filterProductOptions[1].id;
      }
      this.applyFilters();
    },
    onModalCategoryChange(value) {
      this.form.category = value;
      this.updateModalProductOptions();
      if (
        this.form.produit_id &&
        !this.modalProductOptions.some(
          (option) => option.id === this.form.produit_id
        )
      ) {
        this.form.produit_id = null;
      }
      if (!this.form.produit_id && this.modalProductOptions.length === 1) {
        this.form.produit_id = this.modalProductOptions[0].id;
      }
      this.updateUnitPriceConstraints(this.form.produit_id);
      if (this.form.produit_id) {
        this.form.unit_price = this.unitPriceMin;
      }
    },
    onModalProductSelect(option) {
      const productId = option?.id ?? null;
      this.form.produit_id = productId === null ? null : Number(productId);
      this.updateUnitPriceConstraints(this.form.produit_id);
      if (this.form.produit_id) {
        this.form.unit_price = this.unitPriceMin;
      }
    },
    updateUnitPriceConstraints(productId) {
      const product = this.allProducts.find(
        (item) => Number(item.id) === Number(productId)
      );
      if (product) {
        const minPrice = Number(product.prix_vente) || 0;
        this.unitPriceMin = minPrice;
        if (
          this.form.unit_price === null ||
          this.form.unit_price === "" ||
          Number(this.form.unit_price) < minPrice
        ) {
          this.form.unit_price = minPrice;
        }
      } else {
        this.unitPriceMin = 0;
        if (this.form.unit_price === null || this.form.unit_price === "") {
          this.form.unit_price = 0;
        }
      }
    },
    getProductById(productId) {
      return this.allProducts.find(
        (product) => Number(product.id) === Number(productId)
      );
    },
    openCreateModal() {
      this.editingSaleId = null;
      this.resetForm();
      this.form.category = this.filters.category;
      this.updateModalProductOptions();
      if (
        this.filters.productId &&
        this.modalProductOptions.some(
          (option) => option.id === this.filters.productId
        )
      ) {
        this.form.produit_id = this.filters.productId;
        this.updateUnitPriceConstraints(this.form.produit_id);
        this.form.unit_price = this.unitPriceMin;
      } else {
        this.updateUnitPriceConstraints(this.form.produit_id);
        if (this.form.produit_id) {
          this.form.unit_price = this.unitPriceMin;
        }
      }
      if (!this.modalInstance) {
        const element = document.getElementById("unit-sale-modal");
        this.modalInstance =
          Modal.getInstance(element) || new Modal(element, { backdrop: "static" });
      }
      this.modalInstance.show();
    },
    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
      this.editingSaleId = null;
      this.resetForm();
    },
    async submitSale() {
      try {
        if (!this.form.produit_id) {
          toast.error("Sélectionnez un produit.");
          return;
        }
        if (!this.form.quantity || this.form.quantity < 1) {
          toast.error("Indiquez une quantité valide (minimum 1).");
          return;
        }

        const selectedUserId = this.form.user_id || this.currentUserId;
        if (!selectedUserId) {
          toast.error("Impossible de déterminer l'utilisateur vendeur.");
          return;
        }

        const payload = {
          produit_id: Number(this.form.produit_id),
          quantity: Number(this.form.quantity),
          unit_price:
            this.form.unit_price !== null && this.form.unit_price !== ""
              ? Number(this.form.unit_price)
              : null,
          sale_date: this.form.sale_date,
          note: this.form.note || null,
          user_id: Number(selectedUserId),
        };

        if (this.editingSaleId) {
          await updateProductUnitSale(this.editingSaleId, payload);
          await this.loadSales();
          toast.success("Vente mise à jour avec succès.");
        } else {
          await createProductUnitSale(payload);
          await this.loadSales();
          toast.success("Vente enregistrée avec succès.");
        }

        this.closeModal();
      } catch (error) {
        console.error(error);
        toast.error(
          error?.response?.data?.message ||
          "Erreur lors de l'enregistrement de la vente."
        );
      }
    },
    resetForm() {
      this.form = this.getEmptyForm();
      if (this.currentUserId) {
        this.form.user_id = this.currentUserId;
      }
      this.unitPriceMin = 0;
    },
    openEditSale(record) {
      const product = this.getProductById(record.productId);
      this.editingSaleId = record.id;
      this.resetForm();

      this.form.category = product?.categorie_produit || null;
      this.updateModalProductOptions();

      if (
        !this.modalProductOptions.some((option) => option.id === record.productId)
      ) {
        this.form.category = null;
        this.updateModalProductOptions();
      }

      this.form.produit_id = record.productId;
      this.updateUnitPriceConstraints(this.form.produit_id);

      const productPrice = product ? Number(product.prix_vente) || 0 : 0;
      const unitPriceValue =
        record.unitPriceValue !== null && record.unitPriceValue !== undefined
          ? record.unitPriceValue
          : this.unitPriceMin || productPrice;

      this.form.unit_price = unitPriceValue;
      this.form.quantity = Number(record.quantity || 1);
      const saleDateValue =
        this.extractDatePart(record.saleDateIso) ||
        this.extractDatePart(record.createdAtIso) ||
        this.form.sale_date;
      this.form.sale_date = saleDateValue;
      this.form.note = record.noteRaw ?? (record.note === "—" ? "" : record.note);
      this.form.user_id = record.userId || this.currentUserId;

      if (!this.modalInstance) {
        const element = document.getElementById("unit-sale-modal");
        this.modalInstance =
          Modal.getInstance(element) || new Modal(element, { backdrop: "static" });
      }
      this.modalInstance.show();
    },
    async confirmDeleteSale(record) {
      if (!this.isAdminUser) {
        toast.error("Vous n'avez pas l'autorisation de supprimer cette vente.");
        return;
      }

      // Guard against double execution
      if (this._deletingId === record.id) return;
      this._deletingId = record.id;

      const result = await Swal.fire({
        title: "Supprimer cette vente ?",
        text: "Cette action est définitive.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
      });

      if (!result.isConfirmed) {
        this._deletingId = null;
        return;
      }

      try {
        await deleteProductUnitSale(record.id);
        this.salesData = this.salesData.filter((row) => row.id !== record.id);
        toast.success("Vente supprimée avec succès.");
      } catch (error) {
        console.error(error);
        toast.error(
          error?.response?.data?.message ||
          "Erreur lors de la suppression de la vente."
        );
      } finally {
        this._deletingId = null;
      }
    },
  },
  watch: {
    'form.produit_id'(newVal) {
      this.updateUnitPriceConstraints(newVal);
    },
  },
  async mounted() {
    const current = getCurrentUser();
    if (current && current.id != null) {
      this.currentUserId = Number(current.id);
    }
    this.currentUserRole = current?.role ?? null;
    await this.loadInitialData();
    await this.loadSales();
  },
  beforeUnmount() {
    if (this.modalInstance) {
      this.modalInstance.hide();
      this.modalInstance = null;
    }
  },
};
</script>

<style scoped>
.table-top .form-label {
  font-weight: 500;
  margin-bottom: 6px;
}

.table-top {
  display: block;
}
</style>
